import type { SurveyAnswerValue, SurveyPanelAnswerValue } from '@coorum-research/shared-common/types/answer.type'
import type { SurveyElementJson } from '@coorum-research/shared-common/types/survey-json.type'
import type { Question } from 'survey-core'
import { isSurveyImageAnswerArray } from '@coorum-research/shared-common/utils/answer.util'

/**
 * パネルデータを正規化する
 *
 * この関数は以下の2つの型をサポートする：
 * 1. Question型 (survey-core依存): 回答表示用コンポーネント
 * 2. SurveyElementJson型（独自定義）: 回答入力用コンポーネント
 *
 * memo:
 * - 回答表示用コンポーネント（SurveyQuestionAnswerPanel）は、survey-coreを利用
 * - 回答入力用コンポーネント（SurveyElementPanel）はSurveyElementJsonを利用
 * - 同じデータ正規化ロジックを両方のケースで再利用するため、両方の型をサポートする
 *
 * @param rawPanelData 生のpanelデータ
 * @param panelElements パネル内の要素
 * @returns 正規化されたpanelデータ
 */
export function normalizePanelData(
  rawPanelData: SurveyAnswerValue,
  panelElements: (Question | SurveyElementJson)[],
): SurveyPanelAnswerValue {
  let panelAnswerData: SurveyPanelAnswerValue = {}

  if (isSurveyImageAnswerArray(rawPanelData)) {
    // 配列の場合（ファイル質問の値が直接配列として保存されている場合）
    const fileElement = panelElements.find((q) => {
      if ('getType' in q) {
        return q.getType() === 'file'
      }
      return q.type === 'file'
    })
    if (fileElement) {
      panelAnswerData = {
        [fileElement.name]: rawPanelData,
      }
    }
  } else if (typeof rawPanelData === 'object' && rawPanelData !== null && !Array.isArray(rawPanelData)) {
    // オブジェクトの場合（既にネストされた構造の場合）
    panelAnswerData = rawPanelData
  }

  return panelAnswerData
}
